<template>
    <div id="goBackTop" @click="scrollToTop">
        <div class="giveSave">
            <img src="@/assets/images/customer.png"/>
            <p>技术支持</p>
            <div class="linkToqq">
                <img src="@/assets/images/linktoQQ1.jpg">
                <p class="name"><img src="@/assets/images/company-icon.png"><span>&nbsp;&nbsp;韵达开放平台QQ交流①群</span></p>
                <img src="@/assets/images/linktoQQ2.jpg">
                <p class="name"><img src="@/assets/images/company-icon.png"><span>&nbsp;&nbsp;韵达开放平台QQ交流②群</span></p>
            </div>
        </div>
        <div class="backBtn">
            <img src="@/assets/images/goBacktop.png"/>
            <p>回到顶部</p>
        </div>
    </div>
</template>
<script>
export default {
    name:'goTop',
    data(){
        return{

        }
    },
    methods:{
        scrollToTop(){
        let timer=setInterval(function(){
                let scrollTop=document.getElementById("app").scrollTop;
                let ispeed=Math.floor(-scrollTop/6);
                if(scrollTop==0){
                    clearInterval(timer);
                }
                document.getElementById("app").scrollTop = scrollTop+ispeed;
            },30)
        },
    },
    mounted () {},
 
}
</script>
<style lang="less" scoped>
#goBackTop{
    width: 80px;
    height: 160px;
    position: fixed;
    z-index: 2000;
    bottom: 100px;
    right: 30px;
    background: #FFFFFF;
    box-shadow: 0px 4px 16px 0px rgba(46,10,72,0.05);
    border-radius: 8px;
    border: 1px solid #f0f0f0;
    cursor: pointer;
    text-align: center;
    font-size: 12px;
    line-height: 20px;
    .giveSave{
        width: 100%;
        height: 80px;
        padding-top: 8px;
        box-sizing: border-box;
        border-bottom: 1px solid #f0f0f0;
        .linkToqq{
            display: none;
        }
        &:hover{
            .linkToqq{
                display: block;
                position: relative;
                width: 200px;
                height: 340px;
                left: -220px;
                top: -254px;
                background: #FFFFFF;
                padding-top: 20px;
                box-sizing: border-box;
                box-shadow: 0 0 10px#DCDFE6;
                border-radius: 6px;
                img{width:126px;height:auto;}
                .name{
                  height: 30px;
                  line-height: 30px;  
                  img{width: 20px;height:auto;}
                }
            }
        }
    }
    .backBtn{
        width: 100%;
        height: 80px;  
        padding-top: 8px;
        box-sizing: border-box;
        opacity: 0.4;
        img{width: 35px;}
    }


}
</style>